<template>
  <div class="question-paper-package-detail">
    <div class="qd-info">
      <div class="qb-base-info" v-if="type !=5">
        <p>
          {{ type == 1 ? '套卷名称：':'考试名称：'}}
          <span
            v-if="type == 2"
          >[{{detail.exam_type == 1 ? '模拟考试':'正式考试'}}]</span>
          <font>{{detail.name}}</font>
        </p>
        <pre>练习时长：{{detail.limit_time}}   总分：{{detail.score}}分   通过分数：{{detail.pass_score}}分</pre>
        <p>试卷简介：{{detail.exam_description}}</p>
        <i-circle
          class="process"
          :percent="detail.pass_rate"
          :size="80"
          :trail-width="4"
          :stroke-width="5"
          stroke-linecap="square"
          stroke-color="#43a3fb"
        >
          <div class="demo-Circle-custom">
            <p>通过率</p>
            <span>{{detail.pass_rate}}%</span>
          </div>
        </i-circle>
      </div>
      <div class="qb-base-info" v-else>
        <p>
          <span><font>{{ detail.period && detail.period.parent_chapter.title}}</font> > <font>{{detail.period.title}}</font></span>
        </p>

        <p>题目数量:
          <span v-for="(item, _index) in detail.question_type_num" v-if="question_type[_index]"> {{item}}道{{ question_type[_index]}} </span>
        </p>
      </div>
      </div>
    <div class="qd-title" v-if="type !=5">
      关联试卷：
      <font>{{detail.exam_name}}</font>
    </div>
    <Tabs value="student">
      <TabPane label="按学员" name="student">
        <Form :model="searchCondition" :label-width="70" inline>
          <FormItem label="姓名">
            <Input
              v-model="searchCondition.name"
              placeholder="请输入姓名关键字"
              style="width:200px;"
              clearable
              @keydown.native.prevent.enter="search(1)"
            ></Input>
          </FormItem>
          <!-- <FormItem label="分数">
            <Input
              v-model="searchCondition.max_score"
              placeholder="请输入最低分"
              style="width:120px;"
              type="number"
              clearable
              @keydown.native.prevent.enter="search(1)"
            ></Input>－
            <Input
              v-model="searchCondition.min_score"
              placeholder="请输入最高分"
              style="width:120px;"
              type="number"
              clearable
              @keydown.native.prevent.enter="search(1)"
            ></Input>
          </FormItem> -->
          <FormItem class="search-form-btns">
            <div class="btn-wrap form-item-search">
              <Button icon="ios-search" @click="search(1)">搜索</Button>
              <Button icon="md-undo" @click="search(0)">重置</Button>
            </div>
          </FormItem>
        </Form>
        <div class="content">
          <div class="qd-import" v-if="type != 5">
            <p @click="exportResult">导出成绩</p>
            <p>考试人员：{{detail.have_done_num}}/{{detail.all_participator_num}}</p>
          </div>
          <Grid
            ref="grid"
            :columns="tableColumns"
            :data-url="url"
            :search="searchCondition"
            :rowsFormatter="rowsFormatter"
            keyField="id"
            selectType
            method="get"
          >
            <template slot-scope="{row}" slot="action">
              <div>
                <Button type="text" size="small" @click="toDetail(row.id)">查看</Button>
              </div>
            </template>
          </Grid>
        </div>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
export default {
  name: "question-paper-package-detail",
  data() {
    return {
      id: this.$route.query.id,
      type: this.$route.query.type,
      detail: {},
      question_type: {
        judge: '判断题',
        multi_choice: '多选题',
        single_choice: '单选题',
        subject: '简答题',
      },
      searchCondition: {
        name: "",
        max_score: "",
        min_score: "",
        init: function() {
          this.name = "";
          this.max_score = "";
          this.min_score = "";
        }
      },
      tableColumns: [
        { title: "姓名", key: "nickname", align: "center", minWidth: 120 },
        { title: "手机号", key: "mobile", align: "center", minWidth: 120 },
        {
          title: "注册时间",
          key: "register_time",
          align: "center",
          minWidth: 160
        },
        { title: "练习成绩", key: "grade", align: "center", minWidth: 100 },
        {
          title: "提交时间",
          key: "created_at",
          align: "center",
          minWidth: 160
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 100,
          fixed: "right"
        }
      ]
    };
  },
  computed: {
    url() {
      if (this.type == 1) {
        return `/api/exam/practice/reportShow/${this.id}`;
      } else if (this.type == 5) {
        return `/api/exam/exercise-report/reportShow/${this.id}`;
      }  else {
        return `/api/exam/simulation/reportShow/${this.id}`;
      }
    }
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(item => {
        item.created_at = this.$pub.timestampToTime(item.created_at);
        item.register_time = this.$pub.timestampToTime(item.register_time);

        if( this.type == 5 ) {
            item.grade = item.ques_count ? parseInt(item.right_count / item.ques_count*100) + '%' : '0%';
        }else {
          item.grade = item.point;
        }
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.init();
      }
      this.$refs.grid.searchRefresh();
    },
    toDetail(id) {
      let type = 2;
      if( this.$route.query.type == 5 ) {
        type = 5;this.$router.push({
          name: "StudentPaperDetail",
          query: {
            id,
            paper_id: this.id,
            type
          }
        });
      }
      this.$router.push({
        name: this.type == 1 ? "StudentPaperDetail" : "ExamPaperDetail",
        query: {
          id,
          paper_id: this.id,
          type
        }
      });
    },
    async getDetail() {
      let res;
      if (this.type == 1) {
        res = await this.$http.get(`/api/exam/practice/reportBase/${this.id}`);
      }  else if (this.type == 5) {
          res = await this.$http.get(`/api/exam/exercise-report/reportBase/${this.id}`);
        } else {
        res = await this.$http.get(
          `/api/exam/simulation/reportBase/${this.id}`
        );
      }
      res.limit_time = this.limitFormat(res.limit_time);
      this.detail = res;
    },
    limitFormat(time) {
      if (time == -1) {
        time = "无限制";
      } else {
        time = parseInt(time / 60) + "分钟";
        if (time % 60) {
          time = time + (time % 60) + "秒";
        }
      }
      return time;
    },
    exportResult() {
      let url = `/api/exam/practice/exportScore`;
      if (this.type == 2) {
        // 仿真
        url = "/api/exam/simulation/exportScore";
      }else if (this.type == 5) {
        // 仿真
        url = "/api/exam/exercise-report/exportScore";
      }
      this.$http
        .get(url, {
          paper_id: this.id,
          ...this.searchCondition
        })
        .then(res => {
          window.open(res.url);
        });
    }
  },
  created() {
    this.getDetail();
  }
};
</script>

<style lang="scss" scoped>
.qd-info {
  background: #f1f1f1;
  padding: 30px;
  line-height: 20px;
  padding-right: 200px;
  position: relative;
  font-size: 14px;
  p {
    font {
      color: #2d8cf0;
    }
  }
}
.qd-title {
  font-size: 14px;
  line-height: 60px;
  padding-left: 10px;
  font {
    color: #2d8cf0;
  }
}
.process {
  position: absolute;
  right: 50px;
  top: 20px;
}
.demo-Circle-custom {
  p {
    color: #657180;
    font-size: 14px;
    margin: 6px 0 5px;
  }
  span {
    display: block;
    padding-top: 5px;
    color: #657180;
    font-size: 14px;
  }
}
.qd-import {
  display: flex;
  flex-direction: row-reverse;
  padding: 0 20px 10px 0;
  p {
    font-size: 14px;
    &:nth-child(1) {
      color: #2d8cf0;
      padding-left: 20px;
      cursor: pointer;
    }
    &:nth-child(2) {
      color: #657180;
    }
  }
}
</style>
